import OnboardingTile from "./onboarding_tile"
import Header from "./header"

import "./index.scss"

interface Channels {
  brand_color: string
  lrg_monochrome_image_url: string
  module_name: string
  name: string
}

interface Props {
  channels: Array<Channels>
  channelSelected: (moduleName: string) => boolean
  userIsOnboarding: boolean
  onClickBack: () => void
  onNext: () => void
  showFooter: boolean
  toggleChannel: (moduleName: string) => void
}

const ServiceSelection = ({
  channels,
  channelSelected,
  userIsOnboarding,
  onNext,
  showFooter,
  toggleChannel,
  onClickBack,
}: Props) => {
  const headerTitle = userIsOnboarding ? "Welcome to IFTTT!" : "Applet Discovery"

  return (
    <>
      <Header title={headerTitle} onClickBack={onClickBack} />
      <div styleName="container">
        <div>
          <p className="txt-body-3">
            To help you get personalized recommendations, pick at least one of the following that you use regularly.
          </p>
          <ul styleName="service-list">
            {channels.map(c => (
              <li key={c.module_name}>
                <OnboardingTile
                  onClick={() => toggleChannel(c.module_name)}
                  onboardingItem={c}
                  selected={channelSelected(c.module_name)}
                />
              </li>
            ))}
          </ul>
        </div>
      </div>
      {showFooter && (
        <footer styleName="onboarding-footer">
          <div styleName="wide-content">
            {userIsOnboarding && <div>Great choices! Let&rsquo;s learn about Applets now.</div>}
            <button onClick={onNext} className="button-tertiary button-on-color">
              Continue
            </button>
          </div>
          <div styleName="narrow-content">
            <button onClick={onNext} className="button-tertiary button-on-color">
              Continue
            </button>
          </div>
        </footer>
      )}
    </>
  )
}

export default ServiceSelection
